import {
  GRID,
  LABEL_COLUMN,
  MONTH_GAP,
  MONTH_NAMES_HEIGHT,
  TIMELINE_COLUMN,
} from '@/modules/projects/components/Workbench/mapLayout'
import {
  MONTHS_IN_YEAR,
  monthShortName,
} from '@/modules/projects/components/Workbench/period'
import { cn, range } from '@/utils'

// The columns are the same for every account now that the names sit beside them, so one row of
// month names at the top of the map serves the whole file.
export const MonthNames = () => (
  <div
    className={cn(
      'sticky top-0 z-20 flex shrink-0 border-b bg-white px-4',
      MONTH_NAMES_HEIGHT,
    )}
  >
    <div className={LABEL_COLUMN} />
    <div
      className={cn(
        TIMELINE_COLUMN,
        MONTH_GAP,
        'grid items-center text-[10px] uppercase tracking-wide text-ink-subtle',
      )}
      style={{ gridTemplateColumns: GRID }}
    >
      <span />
      {range(MONTHS_IN_YEAR)
        .map((monthIndex) => monthShortName(monthIndex))
        .map((name) => (
          <span key={name} className="text-center">
            {name}
          </span>
        ))}
    </div>
  </div>
)
